import React from 'react';
import { t, props } from 'tcomb-react';
import Amount from '../domain/Amount';
import Color from '../domain/Color';
import HTMLComponent from './HTMLComponent';
import Media from './Media';
import format_discount from '../util/formatDiscount';
import percentage from '../util/percentage';
import format_timeago from '../util/formatTimeAgo';
import get_bundle from '../domain/get_bundle';
import animatePrice from '../util/animatePrice';
import template from 'lodash/string/template';
import cx from 'classnames';

@props({
  doShowConsole: t.Bool,
  locale: t.maybe(t.Obj),
  themeBgColor: t.maybe(Color),
  themeBtnColor: t.maybe(Color),
  themeBgFontColor: t.maybe(Color),
  themeBtnFontColor: t.maybe(Color),
  message: t.maybe(t.ReactElement),
  product: t.maybe(t.Obj),
  goPurchase: t.maybe(t.Func),
  goBuildOrder: t.maybe(t.Func),
  doReduce: t.maybe(t.Func),
  oldPrice: t.maybe(Amount),
  doShowTimeAgo: t.Bool,
  doShowBonus: t.Bool,
  doShowProductName: t.Bool,
  doShowArrowRight: t.Bool
})
export default class Console extends React.Component {

  componentDidMount() {
    // 25, 23.5
    //animatePrice(this.props.product.list_price, this.props.product.runtime.price, this.props.product);
    animatePrice(this.props.product.list_price, this.props.product.runtime.price, this.props.product);
  }

  styleBgColorConsole() {
    return {
      backgroundColor: this.props.themeBgColor,
      color: this.props.themeBgFontColor
    };
  };

  styleBtnColorConsole() {
    return {
      backgroundColor: this.props.themeBtnColor,
      color: this.props.themeBtnFontColor
    };
  };

  styleBorderRxColorConsole() {
    return {borderRightColor: this.props.themeBgColor};
  };

  styleBorderSxColorConsole() {
    return {borderLeftColor: this.props.themeBgColor};
  };

  getDiscount() {
    return this.props.product.format_amount(this.props.locale, this.props.product.list_price - this.props.product.runtime.price)
  }

  getTimeAgo() {
    if (!this.props.doShowTimeAgo) {
      return null;
    }

    const locale = this.props.locale;
    //fixme
    const timeagoLabel = template(get_bundle(locale).product.console.timeago)({
      timeago: ""
    });
    const timeagoValue = format_timeago(locale, this.props.product.runtime.delta);

    return (
      <div>
        <Media className="timeago">
          {timeagoLabel}
        </Media>
        <div>
          {timeagoValue}
        </div>
      </div>
    );
  }

  getPrice() {
    const {locale, product, oldPrice } = this.props;
    const price = !t.Nil.is(oldPrice) ? oldPrice : product.runtime.price;
    return product.format_amount(locale, price);
  }

  getBonus() {
    if (!this.props.doShowBonus) {
      return null;
    }

    if (!this.props.product.runtime.bonus) {
      return null;
    }

    const {locale, product } = this.props;

    return (
      <div>
        <Media className="bonus">
          <font className='bonus-label'>
            <HTMLComponent>
              {get_bundle(locale).product.console.bonus}
            </HTMLComponent>
          </font>
          &nbsp; {product.format_amount(locale, product.runtime.bonus)}
        </Media>
      </div>
    );
  }

  getArrowLeft() {
    if (this.props.message || this.props.doShowArrowRight) {
      return null;
    }
    return (<div className="triangle-left small-hide" style={this.styleBorderRxColorConsole()}></div>);
  }

  getArrowRight() {
    if ( !this.props.doShowArrowRight ) {
      return null;
    }
    return (<div className="triangle-right small-hide" style={this.styleBorderSxColorConsole()}></div>);
  }

  getAction() {
    const product = this.props.product;

    if (product.runtime.payments_overflow) {
      return this.getPaymentsOverflowLink();
    }
    if (product.runtime.is_max_items_overflow) {
      return this.getMaxItemsOverflowLabel();
    }
    return this.getBuildOrderButton();
  }

  getPaymentsOverflowLink() {
    const console_bundle = get_bundle(this.props.locale).product.console;

    const paymentOverflowLabel = console_bundle.payments_overflow[0];
    const paymentOverflowValue = console_bundle.payments_overflow[1];
    return (
      <div>
        <Media className="no-cart">
          {paymentOverflowLabel}
        </Media>
        <div>
          <a href="#" id='go_purchase' onClick={this.goPurchase.bind(this, this.props.product.runtime.payments_overflow)}>
            {paymentOverflowValue}
          </a>
        </div>
      </div>
    );
  }

  getMaxItemsOverflowLabel() {
    const is_max_items_overflow = get_bundle(this.props.locale).product.console.is_max_items_overflow.split("\n");

    const maxItemsOverflowLabel = is_max_items_overflow[0];
    const maxItemsOverflowValue = is_max_items_overflow[1];

    return (
      <div>
        <Media className="no-cart">
          {maxItemsOverflowLabel}
        </Media>
        <div>
          {maxItemsOverflowValue}
        </div>
      </div>
    );
  }

  goBuildOrder = (evt) => {
    if (this.props.product.min_buy_price && this.props.product.runtime.price > this.props.product.min_buy_price) {
      evt.preventDefault();
    }
    else  {
      evt.preventDefault();
      this.props.goBuildOrder();
    }
  }

  getBuildOrderButton() {
    const style = {
      color: this.props.themeBgFontColor,
      border: '1px solid ' + this.props.themeBgFontColor
    };

    const _classname = cx({
      'button_transparent': true,
      'disabled': this.props.product.min_buy_price && this.props.product.runtime.price > this.props.product.min_buy_price 
    });
    
    return (
      <center>
        <button id='go_build_order' className={_classname} style={style} onClick={this.goBuildOrder} href='#'>{this.props.product.getBuyButtonLabel(this.props.locale)}</button>
        {this.getBuilderButtonText()}
      </center>
    );
  }

  getBuilderButtonText() {
    if (!this.props.product.min_buy_price) {
      return null
    }
    if (this.props.product.runtime.price > this.props.product.min_buy_price) {
      
      const label = template(get_bundle(this.props.locale).product.console.min_buy_price_text)({
        min_buy_price: this.props.product.format_amount(this.props.locale, this.props.product.min_buy_price) 
      });


      return (
          <div style={{marginTop:"10px", color:"#aaa"}}><b>{label}</b></div>
        ) 
      }
  }

  goPurchase(purchaseId, evt) {
    evt.preventDefault();
    this.props.goPurchase(purchaseId);
  }

  doReduce = (evt) => {
    evt.preventDefault();
    this.props.doReduce();
  }

  getButtonReduce = () => {
    if (!this.props.doReduce) {
      return null;
    }
    const bundle = get_bundle(this.props.locale).product;
    return (
      <button id="do_reduce" onClick={this.doReduce} className="big" style={this.styleBtnColorConsole()}>{bundle.console.do_reduce}</button>
    );
  }

  getProductName = () => {
    if (!this.props.doShowProductName) {
      return null;
    }
    return (<h2 className="large-hide small-show">{this.props.product.name}</h2>);
  }

  render() {
    if (!this.props.doShowConsole) {
      return null;
    }

    const bundle = get_bundle(this.props.locale).product;

    return (
      <div id="console" style={this.styleBgColorConsole()} >
        {this.props.message}
        <div className="box">
          {this.getProductName()}
          <h1><label>{bundle.console.price}</label><br/><span id="price">{this.getDiscount()}</span></h1>
          <h4 id="discount" style={{marginBottom: "10px"}}>{bundle.console.cash_or_buy}{this.getPrice()}</h4>
          { this.getButtonReduce() }
          { this.getTimeAgo() }
          { this.getBonus() }
          { this.getAction() }
          { this.getArrowLeft() }
          { this.getArrowRight() }
        </div>
      </div>
    );
  }
}




/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/components/Console.js
 **/